// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"reportTemplates_wrapper__3hw-1"};